import { observer } from "mobx-react-lite"
import { ReactComponent as DownArrow } from "../../images/icons/downArrow.svg";
import { useEffect, useRef, useState } from "react";

const Dropbox = ({ textValue, isRight, children, changeOpened, isOpen, isError }) => {
    const [hasScroll, setHasScroll] = useState(false);
    const scrollElement = useRef(null);
    const dropboxList = useRef(null);

    const toggleDropbox = () => {
        // setIsOpen(!isOpen);
        changeOpened(!isOpen);
    }

    useEffect(() => {
        if (scrollElement.current.scrollHeight > scrollElement.current.clientHeight) setHasScroll(true);
    }, []);

    return (
        <div className="dropboxParrent">
            <div className={`${isOpen ? 'dropbox active':'dropbox'} ${isError !== undefined ? (isError === true ? "error" : "") : ""}`} onClick={toggleDropbox}>
                <div className="dropbox_text">
                    <div className="dropbox_value">{textValue}</div>
                    {/* <div className="dropbox_newValue">от 1 до 10 и пиздец</div> */}
                </div>
                <button className="activeButton"><DownArrow/></button>
            </div>
            <div className={`${isOpen ? "dropbox_list opened" : "dropbox_list"}${isRight == true ? " right" : ""}`} ref={dropboxList}>
                {/* <button className="activeButton">Закрыть</button> */}
                <ul ref={scrollElement} className={hasScroll ? "scrolled":""}>
                    {children}
                </ul>
            </div>
        </div>
    )
}

export default observer(Dropbox);
